import { Sound } from '@benzinga/session';
import { SafeError, SafePromise } from '@benzinga/safe-await';
import { AuthorAlert, CategoriesAlert } from './entities';

export interface IncomingCategory {
  channel_description: string;
  channel_id: string;
  channel_name: string;
  channel_path: string;
  count_week: number;
  sound: Sound;
  subscription_type: string;
  tids: {
    name: string;
    tid: string;
  }[];
}

interface RestfulResult<DATA> {
  data: DATA;
  response_code: number;
}

export type IncomingCategoryResult = RestfulResult<Record<IncomingCategory['channel_id'], IncomingCategory>>;
export type IncomingAuthorResult = RestfulResult<Record<AuthorAlert['alert_id'], AuthorAlert | AuthorAlert[]>>;
export type IncomingCategoryUpdateResult = RestfulResult<Record<'channel_id', boolean>>;

export const ingresCategory = async (
  ingressCategory: SafePromise<IncomingCategoryResult>,
): SafePromise<CategoriesAlert[]> => {
  const rawCategory = await ingressCategory;

  if (rawCategory.err) {
    return { err: rawCategory.err };
  } else {
    if (rawCategory.ok?.data) {
      return {
        ok: Object.values(rawCategory.ok.data).map(category => ({
          children: [],
          description: category.channel_description,
          id: category.channel_id,
          name: category.channel_name,
          realtimeEmails: !!category.subscription_type,
          sound: category.sound,
          tids: category.tids.map((tid: { tid: string }) => parseInt(tid.tid, 10)),
        })),
      };
    } else {
      return { err: new SafeError('did not get a valid category', 'invalid_category') };
    }
  }
};
